export default __webpack_public_path__ + "static/media/13.f1f04cc4.svg";